import React from 'react';
import './SegmentedBar.css';

/**
 * SegmentedBar Component
 * Horizontal tab component for navigation
 */
const SegmentedBar = ({ 
  tabs = [], 
  activeTab, 
  onTabChange, 
  className = '' 
}) => {
  return (
    <div className={`segmented-bar ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`segmented-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.icon && <span className="tab-icon">{tab.icon}</span>}
          <span className="tab-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default SegmentedBar;
